import { render, staticRenderFns } from "./SlideTable.vue?vue&type=template&id=652ad844&scoped=true&"
import script from "./SlideTable.vue?vue&type=script&lang=js&"
export * from "./SlideTable.vue?vue&type=script&lang=js&"
import style0 from "./SlideTable.vue?vue&type=style&index=0&id=652ad844&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "652ad844",
  null
  
)

export default component.exports